<ng-container [ngSwitch]="titleSize">
  <h1 class="title" *ngSwitchCase="'H1'">{{title}}</h1>
  <h2 class="title" *ngSwitchCase="'H2'">{{title}}</h2>
  <h3 class="title" *ngSwitchCase="'H3'">{{title}}</h3>
  <h4 class="title" *ngSwitchCase="'H4'">{{title}}</h4>
  <h5 class="title" *ngSwitchCase="'H5'">{{title}}</h5>
  <h5 class="title" *ngSwitchCase="'H6'">{{title}}</h5>
  <div class="title" *ngSwitchDefault>{{title}}</div>
</ng-container>
